import StateOptions from 'constants/StateOptions'
const areaArray = StateOptions.filter((option) => option.key !== 'all').map((option) => option.text)

export default areaArray
